import { render } from "./dsp-record.vue?vue&type=template&id=fa29ac82"
import script from "./dsp-record.js?vue&type=script&lang=js"
export * from "./dsp-record.js?vue&type=script&lang=js"

import "./dsp-record.vue?vue&type=style&index=0&id=fa29ac82&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__